// src/components/Map.js
import {
    MapContainer,
    TileLayer,
    WMSTileLayer,
    useMap,
    GeoJSON,
    useMapEvent,
    ZoomControl,
    ScaleControl
  } from "react-leaflet";
  import { connect, useDispatch } from "react-redux";
  import React from "react";
  import L from "leaflet";

  import "leaflet.markercluster";
  import "leaflet.markercluster/dist/MarkerCluster.css";
  import "leaflet.markercluster/dist/MarkerCluster.Default.css";
  
  import { changeMapZoom } from "../actions";
  import popup_preloaded from "../utils/data_popup.json";

  window.L = L;

  const mapStateToProps = (state) => ({ map: state.MapReducer });

  /** SRTM DEM layer id (külön kezeljük: legalul legyen) */
  const DEM_ID = "allum_project:SRTM90_4326";
  // csak a táncos base layerre akarjuk a link ikonokat
  const DANCE_LAYER_ID = "allum_project:tanc_base_layer_1910";

  function safeCount(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }

  function buildLocalitiesUrl(base, localityName) {
    // URL-ben Localities=[ "Település" ] JSON-ként menjen
    const encoded = encodeURIComponent(JSON.stringify([localityName]));
    return `${base}?Localities=${encoded}`;
  }
  
  function ClickEvent(props) {
    const map = useMapEvent("click", (e) => {
    // ✅ régi whitelist helyett: csak akkor próbálkozunk popup-pal,
    // ha a data_popup.json tartalmaz konfigurációt ehhez a layerhez
    const hasPopupConfig = (popup_preloaded || []).some(
      (x) => x.layer === props.activeLayer
    );
    if (!hasPopupConfig) return;
    
      Object.keys(map._layers).map((_lk) => {
        let _l = map._layers[_lk];
        if (_l.options.ltype === "marker") map.removeLayer(_l);
      });
  
      const sw = map.options.crs.project(map.getBounds().getSouthWest());
      const ne = map.options.crs.project(map.getBounds().getNorthEast());
      const BBOX = sw.x + "," + sw.y + "," + ne.x + "," + ne.y;
      const WIDTH = map.getSize().x;
      const HEIGHT = map.getSize().y;
  
      const X = Math.trunc(map.layerPointToContainerPoint(e.layerPoint).x);
      const Y = Math.trunc(map.layerPointToContainerPoint(e.layerPoint).y);
      const URL =
        "http://193.225.239.5/geoserver/allum_project/wms?" +
        "SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&" +
        "LAYERS=" +
        props.activeLayer +
        "&QUERY_LAYERS=" +
        props.activeLayer +
        "&" +
        "BBOX=" +
        BBOX +
        "&FEATURE_COUNT=1&HEIGHT=" +
        HEIGHT +
        "&WIDTH=" +
        WIDTH +
        "&" +
        "INFO_FORMAT=application%2Fjson&TILED=false&CRS=EPSG%3A3857&X=" +
        X +
        "&Y=" +
        Y +
        "";
  
      const categories = {};
      for (const item of popup_preloaded) {
        if (item.layer === props.activeLayer) {
          if (item.category in categories) categories[item.category].push(item);
          else categories[item.category] = [item];
        }
      }
  
      fetch(URL)
        .then((r) => r.json())
        .then((r) => {
          if (r.features.length === 0) return;
          let feature = r.features[0];
          let html =
            "<div style='max-height:200px; overflow-y:auto; padding-right:10px;'>";
  
          Object.entries(categories).map((entry) => {
            const popup_category = entry[0];
  
            if (popup_category == "Base data") {
              html +=
                "<button class='popup_accordion active'><i id='arw' class='arrow down'></i><b>" +
                popup_category +
                "</b></button>";
              html += "<div class='popup_panel' style='display:block'>";
            } else {
              html +=
                "<button class='popup_accordion'><i id='arw' class='arrow right'></i><b>" +
                popup_category +
                "</b></button>";
              html += "<div class='popup_panel'>";
            }
  
            // ✅ Kategória elemei alapján renderelünk, nem feature.properties alapján
            (categories[popup_category] || []).forEach((cfg) => {
              const fp = cfg.field;

              // ha nincs ilyen property a feature-ben, ne írjuk ki
              if (!feature.properties || !(fp in feature.properties)) return;

              let v = feature.properties[fp];

              if (v == null || v === "") v = "no data";
              if (v === "HAMIS") v = "No";
              if (v === "IGAZ") v = "Yes";

              html +=
                "<div class='popup_row'>" +
                cfg.title +
                ": <b>" +
                v +
                "</b></div>";
            });

            // ✅ Néptáncos layer: link ikonok csak a Base data kategóriában
            if (props.activeLayer === DANCE_LAYER_ID && popup_category === "Base data") {
              const name = (feature.properties?.name ?? "").toString().trim();
              if (name) {
                const tf = safeCount(feature.properties?.tancfolyamat_count);  // Films + Dances
                const kz = safeCount(feature.properties?.kezirat_count);       // Scripts
                const fo = safeCount(feature.properties?.foto_osszes_count);   // Photos

                const links = [];

                if (tf > 0) {
                  links.push({
                    icon: "🎬",
                    title: "Films",
                    url: buildLocalitiesUrl("https://neptanctudastar.abtk.hu/hu/films", name),
                  });
                  links.push({
                    icon: "🕺",
                    title: "Dances",
                    url: buildLocalitiesUrl("https://neptanctudastar.abtk.hu/hu/dances", name),
                  });
                }

                if (kz > 0) {
                  links.push({
                    icon: "📜",
                    title: "Manuscripts",
                    url: buildLocalitiesUrl("https://neptanctudastar.abtk.hu/hu/scripts", name),
                  });
                }

                if (fo > 0) {
                  links.push({
                    icon: "📷",
                    title: "Photos",
                    url: buildLocalitiesUrl("https://neptanctudastar.abtk.hu/hu/photos", name),
                  });
                }

                if (links.length) {
                  html += "<div class='popup_row' style='margin-top:6px;'>";

                  links.forEach((l) => {
                    html +=
                      `<a href="${l.url}" target="_blank" rel="noopener noreferrer" ` +
                      `title="${l.title}" ` +
                      `style="text-decoration:none; margin-right:10px; font-size:18px;">` +
                      `${l.icon}</a>`;
                  });

                  html += "</div>";
                }
              }
            }            
  
            html += "</div>";
          });
  
          html += "</div>";
  
          const marker = L.popup()
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(html)
            .openOn(map);
  
          var acc = document.getElementsByClassName("popup_accordion");
          marker.on("popupclose", () => {
            Object.keys(map._layers).map((_lk) => {
              let _l = map._layers[_lk];
              if (_l.options.ltype === "marker") map.removeLayer(_l);
            });
          });
          marker._closeButton.onclick = function () {
            Object.keys(map._layers).map((_lk) => {
              let _l = map._layers[_lk];
              if (_l.options.ltype === "marker") map.removeLayer(_l);
            });
          };
  
          for (let i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
              this.classList.toggle("active");
              var arw = this.firstElementChild;
              var panel = this.nextElementSibling;
              if (panel.style.display === "block") {
                panel.style.display = "none";
                arw.className = "arrow right";
              } else {
                panel.style.display = "block";
                arw.className = "arrow down";
              }
            });
          }
        });
    });
  
    return null;
  }
  
  const MapLayers = (props) => {
    let layers = Object.keys(props.map.layers).map(
      (layerId) => props.map.layers[layerId]
    );
    layers = layers.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });
  
    return (
      <div>
        {layers.map((layer) => {
          if (!layer.active) return "";
          switch (layer.type) {
            case "WMS": {
              const _params = {
                layers: layer.id,
                format: "image/png",
                tiled: true,
                transparent: true
              };
              if (layer.sldBody) {
                _params["sld"] =
                  "http://193.225.239.5/backend2/getSld/" + layer.sldBody;
              }
              return props.map.zoom >= layer.minZoom ? (
                <WMSTileLayer
                  key={layer.id}
                  url={layer.url}
                  params={_params}
                  opacity={layer.opacity ?? 1}
                  zIndex={400}
                  maxZoom={24}
                />
              ) : (
                ""
              );
            }
            case "BASE": {
                // ✅ HELYES rétegrend:
                // 1) DEM legalul (ha be van kapcsolva)
                // 2) Default overlayek legfelül (SRTM nélkül)
                const enabled = Array.isArray(props.map.enabledBmaps)
                  ? props.map.enabledBmaps
                  : [];
  
                const hasDem = enabled.includes(DEM_ID);
                const overlayIds = enabled.filter((id) => id !== DEM_ID);
  
                return props.map.zoom >= layer.minZoom ? (
                  <>
                    {/* 1) SRTM (DEM) – legalul */}
                    {hasDem ? (
                      <WMSTileLayer
                        maxZoom={24}
                        key={`${layer.id}__DEM`}
                        url={layer.url}
                        zIndex={50}
                        opacity={layer.opacity}
                        params={{
                          layers: DEM_ID,
                          format: "image/png",
                          tiled: true,
                          transparent: false
                        }}
                      />
                    ) : (
                      ""
                    )}
  
                    {/* 2) Default overlayek – legfelül */}
                    {overlayIds.length ? (
                      <WMSTileLayer
                        maxZoom={24}
                        key={`${layer.id}__OVERLAY`}
                        url={layer.url}
                        zIndex={500}
                        opacity={layer.opacity}
                        params={{
                          layers: overlayIds.join(","),
                          format: "image/png",
                          tiled: true,
                          transparent: true
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                );
              }
            case "VECTOR":
              return (
                <GeoJSON
                  attribution="&copy; credits due..."
                  data={layer.data}
                  key={layer.id}
                />
              );
            case "TILE":
              return <TileLayer key={layer.id} url={layer.url} maxZoom={24} />;
            case "VECTOR_GJ":
              return <GeoJSON data={layer.data} key={layer.id} />;
          }
          return "";
        })}
      </div>
    );
  };
  
  function ZoomEvent() {
    const dispatch = useDispatch();
    const map = useMapEvent("zoom", () => {
      dispatch(changeMapZoom(map.getZoom()));
    });
    return null;
  }
  
  function MapBridge() {
    const map = useMap();
    React.useEffect(() => {
      window.__leafletMap = map;
    }, [map]);
    return null;
  }
  
  const Map = (props) => {
    // csak jelzésre használjuk, hogy dualLayerChanged után újra-rendereljen
    const [, setDualTick] = React.useState(0);
    React.useEffect(() => {
      if (typeof window === "undefined") return;
      const onDual = () => setDualTick((t) => t + 1);
      window.addEventListener("dualLayerChanged", onDual);
      return () => window.removeEventListener("dualLayerChanged", onDual);
    }, []);
  
    const renderDual = () => {
      if (typeof window === "undefined") return null;
      const d = window.__dualLayer || {};
      if (!d.enabled || !d.layerId) return null;
  
      const url = d.layerUrl || props.map.layers[d.layerId]?.url;
      if (!url) return null;
  
      const rawOpacity =
        typeof d.opacity === "number"
          ? d.opacity
          : props.map.secondLayer?.opacity ?? 0.7;
      const opacity = Math.max(0, Math.min(1, rawOpacity));
  
      const params = {
        layers: d.layerId,
        format: "image/png",
        transparent: true,
        tiled: true
      };
  
      // SLD választás: MINDIG a dualLayer.sldId az elsődleges (ez a secondhez generált SLD),
      // csak ha ilyen nincs, esünk vissza a Redux-os sldBody-ra.
      if (d.sldId) {
        params.sld =
          "http://193.225.239.5/backend2/getSld/" +
          encodeURIComponent(d.sldId);
      } else if (props.map.layers[d.layerId]?.sldBody) {
        params.sld =
          "http://193.225.239.5/backend2/getSld/" +
          props.map.layers[d.layerId].sldBody;
      }
  
      const key = `dual-${d.layerId}-${params.sld || "no-sld"}-${Math.round(
        opacity * 100
      )}`;
  
      return (
        <WMSTileLayer
          key={`${key}-${params.layers || "no-layer"}-${params.sld || "no-sld"}`}
          url={url}
          maxZoom={24}
          opacity={opacity}
          zIndex={450}
          params={params}
        />
      );
    };
  
    return (
      <MapContainer
        style={{ height: "calc(100vh - 0px)", width: "100%" }}
        center={props.map.center}
        zoomControl={false}
        attributionControl={false}
        zoom={props.map.zoom}
        whenCreated={(mapInstance) => {
          window.__leafletMap = mapInstance;
        }}
      >
        <ZoomControl position="topright" />
        <ScaleControl position="bottomleft" />        
        <ZoomEvent />
        <MapBridge />
        <ClickEvent activeLayer={props.map.activeLayer} />
        <MapLayers map={props.map} />
        {renderDual()}
      </MapContainer>
    );
  };
  
  export default connect(mapStateToProps)(Map);
  